import { isDevMode } from '@angular/core';

/**
 * Returns true for Angular development runtime.
 * Works for `ng serve` and `ng build --configuration development`.
 */
export function isDevServer(): boolean {
  return isDevMode();
}
